/**
 * Unwrap + pass-through normalizers for the 3 subscription GET endpoints.
 * Console vs foodna share the same shapes for purchased plans; foodna may add
 * `paused_dates` / `skipped_dates`. Catalog plans may omit `display_order` or add
 * `portion` / `free_days` — catalog helpers already tolerate both.
 */
import { unwrapEnvelopeOrRaw } from '../../../query/normalizers/unwrapEnvelope';
import type {
  CustomerSubscriptionsFlatApiResponse,
  CustomerSubscriptionsListApiResponse,
  CustomerSubscriptionsNewApiResponse,
} from '../rawTypes';

export function normalizeSubscriptionSubDataResponse(raw: unknown): CustomerSubscriptionsFlatApiResponse {
  const data = unwrapEnvelopeOrRaw<CustomerSubscriptionsFlatApiResponse | { subscriptions?: unknown }>(raw);
  if (data && typeof data === 'object' && 'subscriptions' in data) {
    return data as CustomerSubscriptionsFlatApiResponse;
  }
  return { subscriptions: Array.isArray(data) ? (data as CustomerSubscriptionsFlatApiResponse['subscriptions']) : [] };
}

export function normalizeSubscriptionNewResponse(raw: unknown): CustomerSubscriptionsNewApiResponse {
  const data = unwrapEnvelopeOrRaw<CustomerSubscriptionsNewApiResponse | { subscriptions?: unknown }>(raw);
  if (data && typeof data === 'object' && 'subscriptions' in data) {
    return data as CustomerSubscriptionsNewApiResponse;
  }
  return { subscriptions: Array.isArray(data) ? (data as CustomerSubscriptionsNewApiResponse['subscriptions']) : [] };
}

export function normalizeSubscriptionListResponse(raw: unknown): CustomerSubscriptionsListApiResponse {
  const data = unwrapEnvelopeOrRaw<CustomerSubscriptionsListApiResponse | { subscriptions?: unknown }>(raw);
  if (data && typeof data === 'object' && 'subscriptions' in data) {
    return data as CustomerSubscriptionsListApiResponse;
  }
  return { subscriptions: Array.isArray(data) ? (data as CustomerSubscriptionsListApiResponse['subscriptions']) : [] };
}
